import React from "react";

export class Param {
    name: string;
    value: string;

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }
}

export class URLUtils {
    static createRequestUrl = (url: string, path: string, params?: Param[]) => {
        let requestURL = `${url}${path}`
        if (params) {
            params.forEach((param, index) => {
                requestURL = index === 0 ? requestURL.concat('?') : requestURL.concat('&');
                requestURL = requestURL.concat(`${param.name}=${param.value}`);
            });
        }
        return requestURL;
    }
}

export class PathConstants {
    static HOME = '/';
    static HISTORICAL = '/historical-guide';

    static ADMIN = '/admin';
    static LOGIN = '/login';

    static AUTH_LOGIN = '/auth/login';
    static AUTH_LOGOUT = '/auth/logout';
    static AUTH_USER_PROFILE = '/auth/profile';

    static LSD_SIMPLE = '/places/lsd-simple';
    static ALL_SIMPLE = '/places/all-simple';
    static PLACES_DETAILS_BY_ID = '/places/details-by-id';
    static PLACES_DETAILS = '/places/details';
    static OMITTED_PLACES = '/places/omitted';
    static CATEGORY_PLACES_SIMPLE = '/places/google/simple';
    static PLACES_OMIT = '/places/omit-place-details';

    static CATEGORIES_GOOGLE_LOCAL = '/categories/google/local';
    static CATEGORIES_REMOVE = '/categories/remove';
    static CATEGORIES_CONNECT = '/categories/connect';
    static CATEGORIES_OMITTED = '/categories/google/not-connected';

    static WEATHER_CURRENT = '/weather/current';
}

export const HOME = React.lazy(() => import('../features/home/view/HomeView'));
export const ADMIN = React.lazy(() => import('../features/admin/view/adminView'));
export const LOGIN = React.lazy(() => import('../features/admin/components/Login'));
